import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { WishlistProduct } from 'api/user/_requests';

const initialState = {
  wishlist: [] as WishlistProduct[],
  loading: true
};

export const wishlistSlice = createSlice({
  name: 'wishlist',
  initialState,
  reducers: {
    setWishlist: (state, action) => {
      state.wishlist = action.payload;
      state.loading = false;
    },
    addToWishlist: (state, action) => {
      state.wishlist.push(action.payload);
    },
    removeFromWishlist: (state, action: PayloadAction<WishlistProduct>) => {
      state.wishlist = state.wishlist.filter(
        item =>
          item.productId !== action.payload.productId ||
          item.variantId !== action.payload.variantId
      );
    }
  }
});

export const { setWishlist, addToWishlist, removeFromWishlist } =
  wishlistSlice.actions;
export default wishlistSlice.reducer;
